/*
 * Unified floating button: club panel + back to top.
 *
 * Native port of the Variant experience "איחוד-כפתורים". Markup:
 * snippets/floating-unified-button.liquid, styles: assets/custom.css.
 *
 * Only the two clicks that cannot be expressed in markup live here. The
 * WhatsApp area is a plain link rendered by Liquid, and the widgets this
 * button replaces are hidden in CSS, so the polling, the mutation observer and
 * the re-render loop the original carried are all gone.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-floating-stack]');
  if (!root) return;

  var clubButton = root.querySelector('[data-floating-stack-club]');
  var topButton = root.querySelector('[data-floating-stack-top]');

  // The club panel belongs to the Valuecard widget, which renders its own tab
  // (hidden on mobile, see custom.css). There is no public API for it, so
  // opening it means clicking its tab - exactly what the original did.
  if (clubButton) {
    clubButton.addEventListener('click', function () {
      var widget = document.querySelector('.vc-widget-left');
      if (widget) widget.click();
    });
  }

  if (topButton) {
    topButton.addEventListener('click', function () {
      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }
})();
